<template>
  <div
    class="relative flex-middle"
    v-bind="$attrs"
    :disabled="disabled || undefined">
    <input
      :disabled="disabled || undefined"
      class="cursor-pointer width-expand absolute-cover z-level-2"
      style="opacity: 0"
      ref="actualFileInput"
      type="file"
      v-bind="fileInputAttrs"
      @change="changeHandler" />
    <span class="">
      {{ finalPlaceholder }}
    </span>

    <icon
      v-bind="iconProps"
      v-if="modelValue"
      class="cursor-pointer field__icon field__icon--end relative"
      style="z-index: var(--z-3)"
      :theme="iconTheme"
      :icon="'x'"
      @click="value = null" />
  </div>
</template>

<script>
import SimpleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/simpleInput.js";

export default {
  mixins: [SimpleInputMixin],
  emits: ["update:modelValue"],
  props: {
    disabled: {},
    placeholder: {},
    label: {},
    iconProps: {},
    iconTheme: {},
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    fileInputAttrs() {
      let attrs = this.inputAttrs;
      delete attrs.class;
      return attrs;
    },
    finalPlaceholder() {
      const maxFileNameLength = 20;
      const ellipsisChars = "…";
      function shortenFileName(name, max = maxFileNameLength) {
        if (name.length <= max) {
          return name;
        }

        // keep extension
        const dot = name.lastIndexOf(".");
        const ext = dot > 0 ? name.slice(dot) : "";
        const room = max - ext.length - ellipsisChars.length;

        if (room <= 0) {
          return name.slice(0, max - ellipsisChars.length) + ellipsisChars;
        }

        return name.slice(0, room) + ellipsisChars + ext;
      }

      let normalText = this.t(
        this.placeholder
          ? this.placeholder
          : "core.form.fileFieldDefaultPlaceholder"
      );

      if (!this.value) {
        return normalText;
      } else {
        try {
          let fileNames = Array.from(this.value).map((item) =>
            shortenFileName(item.name)
          );
          return fileNames.join(", ");
        } catch (e) {
          console.log(e);
          return "";
        }
      }
    },
  },
  methods: {
    changeHandler(event) {
      this.value = event.target.files;
    },
    promptFileSelection() {
      if (!this.$refs.actualFileInput) {
        return false;
      }
      try {
        this.$refs.actualFileInput.click();
        return true;
      } catch (e) {
        notice(e);
        return false;
      }
    },
    triggerClick() {
      let input = this.$refs.actualFileInput;
      if (Array.isArray(input)) {
        input = input[0];
      }

      try {
        input.click();
      } catch (e) {
        console.log(e);
      }

    }
  },
};
</script>


